import { colors, spaces } from '@99designs/common/core/settings';
import { Package } from '__generated__/Package';
import Heading from 'common/components/Heading';
import BriefPackage from 'projects/components/BriefPackage';
import Header from 'projects/components/Header';
import HeaderUserLayout from 'projects/components/HeaderUserLayout';
import Link from 'projects/components/Link';
import PartnerLogo from 'projects/components/PartnerLogo';
import Box from 'projects/libs/core-components/Box/Box';
import Stack from 'projects/libs/core-components/Stack/Stack';
import PartnerContext from 'projects/PartnerContext';
import { StepState } from 'projects/util/step';
import React, { useContext } from 'react';
import styled from 'styled-components';
import ContentSetting from './ContentSetting';
import { Designer as DesignerInterface } from './User';

interface Props<T> {
    step: StepState<T>;
    designers: Array<DesignerInterface>;
    briefPackage?: Package | null;
}

const BackButton = styled.div`
    margin-left: -${spaces.halfGutter}px;
`;

const Muted = styled.span`
    color: ${colors.fiftyFirstShade};
`;

export default function StepHeader<T>({ step, designers, briefPackage }: Props<T>) {
    const { partner } = useContext(PartnerContext);

    return (
        <ContentSetting>
            <Header title={`${step.currentStep().title} | 99designs`} textAlignment={'left'}>
                <div data-test-id="step-header">
                    <Stack space="space8">
                        {step.hasStepBefore() && (
                            <BackButton>
                                <Link to={step.prevUrl()} variations={['back', 'big-target']}>
                                    {__('Back')}
                                </Link>
                            </BackButton>
                        )}

                        <Box display="flex" alignItems="center">
                            <Box flex={1}>
                                <h2 className={'heading heading--h2 heading--no-margin'}>
                                    {step.currentStep().title}
                                </h2>
                            </Box>
                            <Heading size="h5" margin="no">
                                {step.number.toString().padStart(2, '0')}
                                {' / '}
                                <Muted>
                                    {step
                                        .stepCount()
                                        .toString()
                                        .padStart(2, '0')}
                                </Muted>
                            </Heading>
                        </Box>

                        {!step.isDesignerStep() && designers.length > 0 && (
                            <HeaderUserLayout users={designers} />
                        )}

                        {partner && <PartnerLogo partner={partner} />}

                        {briefPackage && <BriefPackage package={briefPackage} />}
                    </Stack>
                </div>
            </Header>
        </ContentSetting>
    );
}
